var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTitle',{attrs:{"schedule":_vm.schedule,"metadata-items":_vm.metadataList}},[(_vm.schedule.separateAccountManagerFee)?[_vm._v(" "+_vm._s(_vm.schedule.programName || _vm.schedule.name)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }